import React from "react";

export default function PrayerLiturgy() {
  return (
    <main className="pt-24 pb-16 px-6 max-w-5xl mx-auto text-gray-700 leading-relaxed">
      <h1 className="text-3xl font-bold text-center mb-8">Prayer & Liturgy</h1>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Mass Timings</h2>
        <ul className="list-disc list-inside">
          <li>Sunday: 7:00 AM, 9:00 AM, 6:00 PM</li>
          <li>Weekdays: 7:00 AM</li>
          <li>Saturday: 7:00 AM, 6:00 PM (Sunday Liturgy)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Confession</h2>
        <p>
          Confession is available every Saturday evening from 5:00 PM to 5:45
          PM and on request after weekday Masses.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Adoration & Rosary</h2>
        <p>
          Eucharistic Adoration is held every First Friday after morning Mass.
          Parish Rosary prayers are recited every Wednesday at 6:30 PM.
        </p>
      </section>
    </main>
  );
}
